var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommSubscriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0001,
    r: 14,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7813 17.75H14.5418L13.9719 23.1381C13.9694 23.1544 13.9687 23.2025 13.9687 23.2187C13.9687 23.6494 14.3194 24 14.75 24C14.995 24 15.2287 23.8825 15.3838 23.6744L20.8438 15.875C20.9444 15.7406 21 15.5744 21 15.4063C21 14.9756 20.6495 14.625 20.2188 14.625H16.8401L17.4025 9.87307C17.4044 9.85499 17.4056 9.79937 17.4056 9.78129C17.4063 9.35065 17.0557 9 16.625 9C16.38 9 16.1463 9.11753 15.9863 9.33188L11.1562 16.5C11.0556 16.6344 11 16.8006 11 16.9688C11 17.3994 11.3506 17.75 11.7813 17.75Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0001,
    r: 15.9,
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommSubscriptionIcon);
export default __webpack_public_path__ + "static/media/ecommSubscriptionIcon.d2f5f87c6a729efa15ca893984086825.svg";
export { ForwardRef as ReactComponent };